(function () {
  'use strict';

  var body = document.body;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover: hover)').matches;

  /* LENIS — smooth scroll */
  var lenis = null;
  var scrollY = 0;
  var scrollVelocity = 0;

  if (window.Lenis && !reducedMotion) {
    lenis = new window.Lenis({
      duration: 1.15,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smoothWheel: true,
      smoothTouch: false,
      touchMultiplier: 1.2,
      wheelMultiplier: 1.0
    });

    lenis.on('scroll', function (e) {
      scrollY = e.scroll;
      scrollVelocity = e.velocity;
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
  } else {
    window.addEventListener('scroll', function () {
      scrollY = window.scrollY;
    }, { passive: true });
  }

  /* Preloader, sticky-nav, mobile-menu, and custom-cursor modules removed.
     The preloader is owned by snippets/syleksa-curtain.liquid; sticky header +
     mobile drawer are owned by sections/syleksa-header.liquid. Those elements
     (#pre/#nav/#ham/#mobNav/#c-dot/#c-ring) no longer exist here, so the stale
     modules were aborting the script before the reveal observer could run. */

  /* SMOOTH ANCHOR SCROLL (Lenis-aware) */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (!id || id === '#') return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      if (lenis) {
        lenis.scrollTo(target, { offset: -72, duration: 1.4 });
      } else {
        window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 72, behavior: 'smooth' });
      }
    });
  });

  /* SPLIT-TEXT — per-word reveal, masked */
  function splitText(el) {
    var html = el.innerHTML;
    html = html.replace(/<br\s*\/?>/gi, '<br>');
    var lines = html.split('<br>');
    el.innerHTML = '';

    lines.forEach(function (lineHtml, li) {
      var lineEl = document.createElement('span');
      lineEl.className = 'split-line';

      var tmp = document.createElement('div');
      tmp.innerHTML = lineHtml;

      var wordIndex = 0;
      tmp.childNodes.forEach(function (node) {
        if (node.nodeType === 3) {
          var words = node.textContent.split(/\s+/).filter(Boolean);
          words.forEach(function (w) {
            var span = document.createElement('span');
            span.className = 'split-word';
            span.style.transitionDelay = (wordIndex * 0.08) + 's';
            span.textContent = w;
            lineEl.appendChild(span);
            wordIndex++;
          });
        } else if (node.nodeType === 1) {
          var span = document.createElement('span');
          span.className = 'split-word';
          span.style.transitionDelay = (wordIndex * 0.08) + 's';
          span.innerHTML = node.outerHTML;
          lineEl.appendChild(span);
          wordIndex++;
        }
      });

      el.appendChild(lineEl);
      if (li < lines.length - 1) el.appendChild(document.createElement('br'));
    });
  }

  function activateSplit(el) {
    el.querySelectorAll('.split-word').forEach(function (w) { w.classList.add('in'); });
  }

  document.querySelectorAll('[data-split]').forEach(splitText);

  /* INTERSECTION REVEAL — [data-reveal], [data-clip], [data-split], .film-sec */
  function activate(el) {
    if (el.hasAttribute('data-reveal')) el.classList.add('on');
    if (el.hasAttribute('data-clip'))   el.classList.add('in');
    if (el.hasAttribute('data-split'))  activateSplit(el);
    if (el.classList.contains('film-sec')) el.classList.add('on');
  }

  if ('IntersectionObserver' in window) {
    var ioReveal = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { activate(e.target); ioReveal.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -56px 0px' });

    var ioFilm = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('on'); ioFilm.unobserve(e.target); }
      });
    }, { threshold: 0.18 });

    document.querySelectorAll('[data-reveal], [data-clip], [data-split]').forEach(function (el) { ioReveal.observe(el); });
    document.querySelectorAll('.film-sec').forEach(function (el) { ioFilm.observe(el); });
  } else {
    document.querySelectorAll('[data-reveal], [data-clip]').forEach(function (el) { activate(el); });
    document.querySelectorAll('[data-split] .split-word').forEach(function (w) { w.classList.add('in'); });
    document.querySelectorAll('.film-sec').forEach(function (el) { el.classList.add('on'); });
  }

  /* Safety net — force-reveal everything after 5s if anything is still hidden. */
  setTimeout(function () {
    document.querySelectorAll('[data-reveal]:not(.on)').forEach(function (el) { el.classList.add('on'); });
    document.querySelectorAll('[data-clip]:not(.in)').forEach(function (el) { el.classList.add('in'); });
    document.querySelectorAll('.split-word:not(.in)').forEach(function (el) { el.classList.add('in'); });
    document.querySelectorAll('.film-sec:not(.on)').forEach(function (el) { el.classList.add('on'); });
  }, 5000);

  /* Hero split words: trigger on a delay so they coincide with the eyebrow fade-up */
  setTimeout(function () {
    document.querySelectorAll('.hero-h1[data-split] .split-word').forEach(function (w) { w.classList.add('in'); });
  }, 2700);

  /* FAQ ACCORDION */
  document.querySelectorAll('.faq-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item   = btn.closest('.faq-item');
      var isOpen = item.classList.contains('open');

      document.querySelectorAll('.faq-item.open').forEach(function (i) {
        i.classList.remove('open');
        i.querySelector('.faq-btn').setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* HERO IMAGE READY */
  var heroImg = document.getElementById('heroImg');
  if (heroImg) {
    var himg = heroImg.querySelector('img');
    if (himg && himg.complete) heroImg.classList.add('ready');
    else if (himg) himg.addEventListener('load', function () { heroImg.classList.add('ready'); });
  }

  /* MAGNETIC BUTTONS — gold buttons track cursor on hover */
  if (canHover && !reducedMotion) {
    document.querySelectorAll('.btn-gold').forEach(function (btn) {
      btn.style.transition = 'transform .35s cubic-bezier(0.22, 1, 0.36, 1), background .5s, color .5s, border-color .5s, box-shadow .5s';

      btn.addEventListener('mousemove', function (e) {
        var rect = btn.getBoundingClientRect();
        var cx = rect.left + rect.width  / 2;
        var cy = rect.top  + rect.height / 2;
        var dx = (e.clientX - cx) * 0.35;
        var dy = (e.clientY - cy) * 0.35;
        btn.style.transform = 'translate(' + dx + 'px, ' + dy + 'px)';
      });

      btn.addEventListener('mouseleave', function () {
        btn.style.transform = 'translate(0, 0)';
      });
    });
  }

  /* PARALLAX */
  var vline      = document.querySelector('.hero-vline');
  var heroImgEl  = document.querySelector('.hero-img');
  var heroCopy   = document.querySelector('.hero-copy');
  var philImgEl  = document.querySelector('.phil-img img');
  var ritualImg  = document.querySelector('.ritual-img img');
  var filmImg    = document.querySelector('.film-img img');

  function parallaxFor(el, speed, sectionTop, vh) {
    if (!el) return;
    var rel = scrollY - sectionTop;
    if (rel < -vh || rel > vh * 2) return;
    el.style.transform = 'translate3d(0, ' + (rel * speed) + 'px, 0)';
  }

  var philSection    = document.querySelector('.phil-sec');
  var ritualSection  = document.querySelector('.ritual-sec');
  var filmSection    = document.querySelector('.film-sec');

  function getOffsetTop(el) {
    var top = 0;
    while (el) { top += el.offsetTop; el = el.offsetParent; }
    return top;
  }

  var philTop   = philSection   ? getOffsetTop(philSection)   : 0;
  var ritualTop = ritualSection ? getOffsetTop(ritualSection) : 0;
  var filmTop   = filmSection   ? getOffsetTop(filmSection)   : 0;
  var vh = window.innerHeight;

  window.addEventListener('resize', function () {
    vh = window.innerHeight;
    if (philSection)   philTop   = getOffsetTop(philSection);
    if (ritualSection) ritualTop = getOffsetTop(ritualSection);
    if (filmSection)   filmTop   = getOffsetTop(filmSection);
  });

  function parallaxTick() {
    if (scrollY < vh * 1.5) {
      if (vline)    vline.style.transform    = 'translate3d(0, ' + (scrollY * 0.18) + 'px, 0)';
      if (heroImgEl) heroImgEl.style.transform = 'translate3d(0, ' + (scrollY * 0.08) + 'px, 0)';
      if (heroCopy)  heroCopy.style.transform  = 'translate3d(0, ' + (scrollY * 0.06) + 'px, 0)';
    }
    parallaxFor(philImgEl, -0.06, philTop,   vh);
    parallaxFor(ritualImg, -0.05, ritualTop, vh);
    parallaxFor(filmImg,   -0.08, filmTop,   vh);
    requestAnimationFrame(parallaxTick);
  }
  if (!reducedMotion) requestAnimationFrame(parallaxTick);

  /* MOTION SECTION — flowing nano particle canvas */
  (function initMotionParticles () {
    var canvas = document.getElementById('motionCanvas');
    if (!canvas || reducedMotion) return;

    var section = canvas.closest('.motion-sec');
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0, H = 0;
    var particles = [];
    var running = false;
    var raf = 0;
    var LINK_DIST = 130;

    function resize () {
      var rect = canvas.getBoundingClientRect();
      W = rect.width;  H = rect.height;
      canvas.width  = W * dpr;
      canvas.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      seed();
    }

    function seed () {
      var density = Math.min(1, W / 1600);
      var target  = Math.floor((W * H) / 18000 * density) + 24;
      particles = [];
      for (var i = 0; i < target; i++) {
        particles.push({
          x: Math.random() * W,
          y: Math.random() * H,
          vx: (Math.random() - 0.5) * 0.32 + 0.12,
          vy: (Math.random() - 0.5) * 0.14,
          r:  Math.random() * 1.2 + 0.6,
          a:  Math.random() * 0.45 + 0.25
        });
      }
    }

    function tick () {
      ctx.clearRect(0, 0, W, H);

      for (var i = 0; i < particles.length; i++) {
        var p = particles[i];
        p.x += p.vx;
        p.y += p.vy;

        if (p.x < -20) p.x = W + 20;
        if (p.x > W + 20) p.x = -20;
        if (p.y < -20) p.y = H + 20;
        if (p.y > H + 20) p.y = -20;

        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(212, 184, 122, ' + p.a + ')';
        ctx.shadowColor = 'rgba(212, 184, 122, .6)';
        ctx.shadowBlur = 6;
        ctx.fill();
      }
      ctx.shadowBlur = 0;

      for (var a = 0; a < particles.length; a++) {
        var p1 = particles[a];
        for (var b = a + 1; b < particles.length; b++) {
          var p2 = particles[b];
          var dx = p1.x - p2.x;
          var dy = p1.y - p2.y;
          var d  = Math.sqrt(dx * dx + dy * dy);
          if (d < LINK_DIST) {
            var op = (1 - d / LINK_DIST) * 0.22;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.strokeStyle = 'rgba(191, 160, 90, ' + op + ')';
            ctx.lineWidth = 0.5;
            ctx.stroke();
          }
        }
      }

      if (running) raf = requestAnimationFrame(tick);
    }

    function start () { if (!running) { running = true; tick(); section.classList.add('in-view'); } }
    function stop  () { running = false; cancelAnimationFrame(raf); }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) start();
          else stop();
        });
      }, { threshold: 0.1 }).observe(section);
    } else {
      start();
    }

    requestAnimationFrame(resize);
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(resize, 180);
    });
  }());

  /* SCROLL-VELOCITY MARQUEE */
  var marquee = document.querySelector('.strip-track');
  if (marquee && !reducedMotion) {
    var baseDur = 36;
    var targetDur = baseDur;
    var currentDur = baseDur;

    function marqueeTick() {
      var v = Math.min(Math.abs(scrollVelocity || 0), 60);
      targetDur = Math.max(baseDur - v * 0.5, 10);
      currentDur += (targetDur - currentDur) * 0.08;
      marquee.style.animationDuration = currentDur + 's';
      requestAnimationFrame(marqueeTick);
    }
    requestAnimationFrame(marqueeTick);
  }

}());
